/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchRelatedVideos } from "../../features/relatedVideos/relatedVideosSlice";
import RelatedVideo from "./RelatedVideo";

const RelatedVideoList = ({ currentVideoId, tags }) => {
  const dispatch = useDispatch();
  const { relatedVideos, isLoading, isError, error } = useSelector((state) => state.relatedVideos);

  useEffect(() => {
    dispatch(fetchRelatedVideos({ tags, id: currentVideoId }));
  }, [dispatch]); //

  return (
    <div className='col-span-full lg:col-auto max-h-[570px] overflow-y-auto'>
      {isLoading && <div className='col-span-12'>Loading...</div>}
      {!isLoading && !isError && relatedVideos.length === 0 ? (
        <div className='col-span-12'>No Related Videos found</div>
      ) : null}
      {!isLoading && !isError && relatedVideos.length > 0
        ? relatedVideos.map((video) => <RelatedVideo videoDetails={video} key={video.id} />)
        : null}

      {!isLoading && isError ? <div className='col-span-12'>{error}</div> : null}
    </div>
  );
};

export default RelatedVideoList;
